export default __webpack_public_path__ + "static/media/nav_point.8ce0e4c3.svg";